import React from 'react';

import { InteractableMap } from '../../pages/mindmap/interactable-map';
import { useMindmap, X_GAP } from '../../pages/mindmap/use-mindmap';
import { ContextMenus } from './context-menus';
import { Node } from './node';

export const Mindmap = () => {
  const {
    canvas: { lines },
    positioning: { positionedTree },
    dragAndDrop: { onPointerMove, isRootNodeDragging, setIsRootNodeDragging },
    selection: { onMapClick, onDrawingSelection, isEditingNode, isDrawingSelection, setIsDrawingSelection },
    interactableMap: { interactableMapSpring, mindmapHeight, mindmapWidth },
  } = useMindmap();

  let map = <span>Calculating mindmap...</span>;

  if (mindmapHeight && mindmapWidth && positionedTree && interactableMapSpring) {
    map = (
      <div id="app-dialog-mounting-point">
        <InteractableMap
          initialPosition={{
            x: window.innerWidth / 2 - (positionedTree.x + positionedTree.width / 2 - X_GAP / 2),
            y: 150,
          }}
          onMapClick={onMapClick}
          onMove={onPointerMove}
          onDrawingSelection={onDrawingSelection}
          isEditingNode={isEditingNode}
          isRootNodeDragging={isRootNodeDragging}
          setIsRootNodeDragging={setIsRootNodeDragging}
          isDrawingSelection={isDrawingSelection}
          setIsDrawingSelection={setIsDrawingSelection}
        >
          <div style={{ height: '100%', width: '100%', transform: `translate(${-X_GAP / 2 - 1}px, -1px)` }}>
            <div style={{ position: 'absolute' }}>
              <svg height={mindmapHeight} width={mindmapWidth} style={{ stroke: 'black', strokeWidth: 2 }}>
                {Object.values(lines).map(({ topLeftX, topLeftY, bottomRightX, bottomRightY }, i) => (
                  <line
                    key={`${topLeftX}-${topLeftY}-${bottomRightX}-${bottomRightY}`}
                    x1={topLeftX}
                    y1={topLeftY}
                    x2={bottomRightX}
                    y2={bottomRightY}
                  />
                ))}
              </svg>
            </div>
            <div style={{ position: 'absolute', width: mindmapWidth, height: mindmapHeight }}>
              <Node node={positionedTree} />
            </div>
            <ContextMenus />
          </div>
        </InteractableMap>
      </div>
    );
  }

  return map;
};
